import { useParams, useNavigate } from "react-router-dom";
import React, { useRef } from "react";
import Header from "../../components/Header/Header";
import FooterSection from "../../components/FooterSection/FooterSection";
import { t } from "../../i18n";

const blogs = [
  {
    id: 1,
    title: t("blogList.blog1.title"),
    date: t("blogList.blog1.date"),
    author: t("blogList.blog1.author"),
    image: "/images/blog-1.svg",
    content: t("blogList.blog1.content"),
  },
  {
    id: 2,
    title: t("blogList.blog2.title"),
    date: t("blogList.blog2.date"),
    author: t("blogList.blog2.author"),
    image: "/images/blog-2.svg",
    content: t("blogList.blog2.content"),
  },
  {
    id: 3,
    title: t("blogList.blog3.title"),
    date: t("blogList.blog3.date"),
    author: t("blogList.blog3.author"),
    image: "/images/blog-3.svg",
    content: t("blogList.blog3.content"),
  },
];

const BlogDetailSection: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const solutionsRef = useRef<HTMLDivElement>(null);
  const blogRef = useRef<HTMLDivElement>(null);
  const contactRef = useRef<HTMLDivElement>(null);
  const missionRef = useRef<HTMLDivElement>(null);
  const pressRef = useRef<HTMLDivElement>(null);
  const testimonialRef = useRef<HTMLDivElement>(null);
  const showcaseRef = useRef<HTMLDivElement>(null);

  const blogId = Number(id);
  const blog = blogs.find((b) => b.id === blogId);

  if (!blog) {
    return (
      <div className="text-center py-40">
        <h1 className="text-3xl font-bold text-red-600">Blog bulunamadı.</h1>
        <button onClick={() => navigate(-1)} className="mt-6 px-6 py-3 bg-primaryPurple-light text-white rounded-lg">
          Geri Dön
        </button>
      </div>
    );
  }

  return (
    <div>
      <Header />
      <section className="py-20 px-6 md:px-32 bg-white text-gray-800">
        <div className="max-w-5xl mx-auto">
          <img src={blog.image} alt={blog.title} className="rounded-xl  object-cover mb-10 shadow" />
          <p className="text-sm text-gray-500 mb-2">{blog.date}</p>
          <h1 className="text-4xl font-bold mb-6">{blog.title}</h1>
          <article className="text-lg leading-relaxed whitespace-pre-line">{blog.content}</article>
          <button onClick={() => navigate(-1)} className="mt-10 px-6 py-3 bg-primaryGreen text-white rounded-lg hover:bg-primaryGreen-dark transition">
            ← Tüm Bloglara Dön
          </button>
        </div>
      </section>

      <FooterSection
        missionRef={missionRef}
        pressRef={pressRef}
        testimonialRef={testimonialRef}
        blogRef={blogRef}
        showcaseRef={showcaseRef}
        solutionsRef={solutionsRef}
        contactRef={contactRef}
      />
    </div>
  );
};

export default BlogDetailSection;
